import Button from 'components/Shared/Button/Button'
import ManualXMLFileDescription from 'components/Shared/ManualXMLFileDescription/ManualXMLFileDescription'
import useCFDIsZIPUploadContainer from './useCFDIsZIPUploadContainer'

export interface ICFDIsZIPUploadContainerProps {
  file: File | null
  fireZipSizeErrorModal: (
    fileName: string,
    primaryAction: () => void,
    cancelAction: () => void
  ) => Promise<boolean> | undefined
  handleCloseDrawer: () => void
}

const CFDIsZIPUploadContainer = (
  props: ICFDIsZIPUploadContainerProps
) => {
  const { file, fireZipSizeErrorModal, handleCloseDrawer } = props
  const {
    inputFile,
    isUploadingZip,
    fileReceived,
    handleSelectFile,
    handleRemoveFile,
    handleReplaceFileWindow,
    handleUploadFiles,
  } = useCFDIsZIPUploadContainer({
    file,
    fireZipSizeErrorModal,
    handleCloseDrawer,
  })

  return (
    <div className="cfdis-xml-upload-container">
      {fileReceived === null || fileReceived === undefined ? (
        <div>No hay archivos seleccionados</div>
      ) : (
        <>
          <div className="xmls-container-title">
            <span>Se seleccionó el siguiente archivo para cargar</span>
          </div>

          <div className="xmls-container-files-description">
            <ManualXMLFileDescription
              key={`uploaded-zip-${fileReceived.name}-${1}`}
              id={1}
              fileName={fileReceived.name}
              handleRemove={handleRemoveFile}
              handleReplace={handleReplaceFileWindow}
            />

            <input
              type="file"
              id="file-zip"
              accept=".zip"
              ref={inputFile}
              style={{ display: 'none' }}
              onChange={handleSelectFile}
            />
          </div>

          <div className="xmls-container-buttons">
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCloseDrawer}>
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="secondary"
              onClick={handleUploadFiles}
              activity={isUploadingZip}>
              Guardar
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

export default CFDIsZIPUploadContainer
